import { IDOwnerLookupLayout, IDWarehouseLookupLayout } from "../../../common/lookups/Layouts/IdLayouts";
import { CodeLookupLayout, CrateDPLookup, IMLocationLookupLayout, LocationDpLookupLayout } from "../../../common/lookups/Layouts/ImLayouts";
import { WMCodesLookupLayout } from "../../../common/lookups/Layouts/WMLayouts";
import { IM, WM } from "../../../const/constants";
const runtimeParameter = JSON.stringify([
    { RWarehouse: 'RWarehouse' }]);
const locationLookupLayout = IMLocationLookupLayout({ moduleType: WM, runtimeParameter })

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "CrateNumber",
                "tableName": "IMCRATES",
                "label": "Crate Number",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "Dimensions",
                "tableName": "IMCRATES",
                "label": "Dimensions",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "GrossWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Gross Weight Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Net Weight Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "RecordNumber",
                "tableName": "IMCRATES",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "IMCRATES",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationUserId",
                "tableName": "IMCRATES",
                "label": "Creation User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "IMCRATES",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateUserId",
                "tableName": "IMCRATES",
                "label": "Last Update User Id",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CompanyId",
                "tableName": "IMCRATES",
                "label": "Company Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RecordType",
                "tableName": "IMCRATES",
                "label": "Record Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "IMCRATES",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserdefinedCode1",
                "tableName": "IMCRATES",
                "label": "User Defined Code 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserdefinedCode2",
                "tableName": "IMCRATES",
                "label": "User Defined Code 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserdefinedCode3",
                "tableName": "IMCRATES",
                "label": "User Defined Code 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserdefinedCode4",
                "tableName": "IMCRATES",
                "label": "User Defined Code 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserdefinedCode5",
                "tableName": "IMCRATES",
                "label": "User Defined Code 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference1",
                "tableName": "IMCRATES",
                "label": "User Defined Reference 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "tableName": "IMCRATES",
                "label": "User Defined Reference 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "tableName": "IMCRATES",
                "label": "User Defined Reference 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "tableName": "IMCRATES",
                "label": "User Defined Reference 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "tableName": "IMCRATES",
                "label": "User Defined Reference 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
                        {
                "name": "Relationship",
                "tableName": "IMCRATES",
                "label": "Relationship",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SSCCNumber",
                "tableName": "IMCRATES",
                "label": "SSCC Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TareWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Tare Weight",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "VoyageNumber",
                "tableName": "IMCRATES",
                "label": "Voyage #",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Cube",
                "tableName": "IMCRATES",
                "label": "Cube",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "fields": [{
            "name": "Description",
            "tableName": "IMCRATES",
            "label": "Description",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Height",
            "tableName": "IMCRATES",
            "label": "Height",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        ]
    },
    {
        "groupId": 3,
        "fields": [{
            "name": "ReceivedDate",
            "tableName": "IMCRATES",
            "label": "Received Date",
            "type": "datetime",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Width",
            "tableName": "IMCRATES",
            "label": "Width",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        ]
    },
    {
        "groupId": 4,
        "fields": [{
            "name": "ShippedDate",
            "tableName": "IMCRATES",
            "label": "Shipped Date",
            "type": "datetime",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "Depth",
            "tableName": "IMCRATES",
            "label": "Depth",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },]
    }
];
const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RecordNumber",
                "tableName": "IMCRATES",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "tableName": "IMCRATES",
                "label": "Profile",
                "type": "lookup",
                "layout": CrateDPLookup({moduleId: 'WM'}),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "CrateNumber",
                "tableName": "IMCRATES",
                "label": "Crate Number",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Description",
                "tableName": "IMCRATES",
                "label": "Description",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RWarehouse",
                "tableName": "IMCRATES",
                "label": "Warehouse",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "lookupDisplayMode": "grid",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocation",
                "tableName": "IMCRATES",
                "label": "Location",
                "type": "lookup",
                "layout": locationLookupLayout,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ROwner",
                "tableName": "IMCRATES",
                "label": "Owner",
                "type": "lookup",
                "layout": IDOwnerLookupLayout,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ReceivedDate",
                "tableName": "IMCRATES",
                "label": "Received",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ShippedDate",
                "tableName": "IMCRATES",
                "label": "Shipped",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "GrossWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Gross Weight",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "TareWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Tare Weight",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "NetWeightQuantity",
                "tableName": "IMCRATES",
                "label": "Net Weight",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SSCCNumber",
                "tableName": "IMCRATES",
                "label": "SSCC Number",
                "maxLength": 20,
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const AdditionalLayout = [{
    "groupId": 1,
    "label": "",
    "fields": [
        {
            "name": "Dimensions",
            "tableName": "IMCRATES",
            "label": "Dimensions",
            "maxLength": 20,
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Height",
            "tableName": "IMCRATES",
            "label": "Height",
            "type": "number",
            "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Width",
            "tableName": "IMCRATES",
            "label": "Width",
            "type": "number",
            "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Depth",
            "tableName": "IMCRATES",
            "label": "Depth",
            "type": "number",
            "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "Cube",
            "tableName": "IMCRATES",
            "label": "Cube",
            "type": "number",
            "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
    ]
}]
const UserDefinedCodesLayout = [{
    "groupId": 1,
    "label": "",
    "fields": [
        {
            "name": "UserdefinedCode1",
            "localizedField": "USERDEFINEDCODE_1",
            "tableName": "IMCRATES",
            "label": "Code 1",
            "type": "lookup",
            layout: WMCodesLookupLayout({ codeType: '88' }),
            
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserdefinedCode2",
            "tableName": "IMCRATES",
            "label": "Code 2",
            "type": "lookup",
            layout: WMCodesLookupLayout({ codeType: '89' }),
            "localizedField": "USERDEFINEDCODE_2",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "UserdefinedCode3",
            "tableName": "IMCRATES",
            "label": "Code 3",
            "type": "lookup",
            layout: WMCodesLookupLayout({ codeType: '90' }),
            "localizedField": "USERDEFINEDCODE_3",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "UserdefinedCode4",
            "tableName": "IMCRATES",
            "label": "Code 4",
            "type": "lookup",
            layout: WMCodesLookupLayout({ codeType: '91' }),
            "localizedField": "USERDEFINEDCODE_4",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "UserdefinedCode5",
            "tableName": "IMCRATES",
            "label": "Code 5",
            "type": "lookup",
            layout: WMCodesLookupLayout({ codeType: '92' }),
            "localizedField": "USERDEFINEDCODE_5",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
    ]
}, {
    "groupId": 2,
    "label": "",
    "fields": [
        {
            "name": "UserDefinedDate1",
            "tableName": "IDCUSTOMER",
            "label": "Date 1",
            "type": "date",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate2",
            "tableName": "IDCUSTOMER",
            "label": "Date 2",
            "type": "date",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate3",
            "tableName": "IDCUSTOMER",
            "label": "Date 3",
            "type": "date",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate4",
            "tableName": "IDCUSTOMER",
            "label": "Date 4",
            "type": "date",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate5",
            "tableName": "IDCUSTOMER",
            "label": "Date 5",
            "type": "date",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }
    ]
}, {
    "groupId": 3,
    "label": "",
    "fields": [
        {
            "name": "UserDefinedQuantity1",
            "tableName": "IMCRATES",
            "label": "Quantity 1",
            "type": "number", "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity2",
            "tableName": "IMCRATES",
            "label": "Quantity 2",
            "type": "number", "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity3",
            "tableName": "IMCRATES",
            "label": "Quantity 3",
            "type": "number", "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity4",
            "tableName": "IMCRATES",
            "label": "Quantity 4",
            "type": "number", "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity5",
            "tableName": "IMCRATES",
            "label": "Quantity 5",
            "type": "number", "format": "#,###0.00",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }
    ]
}]
const UserDefinedReferencesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedReference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMCRATES",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMCRATES",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMCRATES",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMCRATES",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMCRATES",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
             {
                "name": "UserDefinedComment",
                "tableName": "IMCRATES",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]

    }]
    const wareHouseField = {
        "name": "RWarehouse",
        "tableName": "IMCRATES",
        "label": "Warehouse",
        "type": "lookup",
        "lookupDisplayMode": "grid",
        "required": true,
        "visible": true,
        "isLabelChanged": false,
    }
    const locationField = {
        "name": "RLocation",
        "tableName": "IMCRATES",
        "label": "Location",
        "type": "lookup",
        "lookupDisplayMode": "grid",
        "required": false,
        "visible": true,
        "isLabelChanged": false,
    }
export {
    SearchLayout,
    PrimaryLayout,
    AdditionalLayout,
    UserDefinedCodesLayout,
    UserDefinedReferencesLayout,
    wareHouseField,
    locationField
}